import { render } from "./overdueManage.vue?vue&type=template&id=c333c71c&scoped=true"
import script from "./overdueManage.vue?vue&type=script&lang=js"
export * from "./overdueManage.vue?vue&type=script&lang=js"

import "./overdueManage.vue?vue&type=style&index=0&id=c333c71c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c333c71c"]])

export default __exports__